export enum PaymentProviderClient {
    Stripe = "stripe",
    PCI = "pci",
}
